export enum FormMode {
  CREATE,
  EDIT
}
